<template>
  <div class="fill-and-flex">
    <NumSearch :search-value="searchValue" />
    <KeywordResultsBar :search-value="searchValue" v-if="isKeywordSearch" />
    <NumResults
      :search-value="searchValue"
      :key="searchValue"
      v-else-if="searchValue"
    />
    <Favourites v-else />
  </div>
</template>

<script>
import Favourites from "@/views/Home/Favourite/Favourites";
import KeywordResultsBar from "@/views/Home/KeywordResults/Bar";
import NumSearch from "@/views/Home/NumSearch";
import NumResults from "@/views/Home/NumResults";

export default {
  name: "Home",
  components: {
    Favourites,
    KeywordResultsBar,
    NumSearch,
    NumResults,
  },
  data() {
    return {
      searchValue: null,
    };
  },
  computed: {
    isKeywordSearch() {
      if (!this.searchValue) return null;
      return /\s/g.test(this.searchValue) || !this.searchValue.includes(".");
    },
  },
  watch: {
    $route: {
      deep: true,
      handler(newVal) {
        const newSearch = newVal.query.s;
        if (newSearch) {
          this.handleSearch(newSearch);
        } else {
          this.clearSearch();
        }
      },
      immediate: true,
    },
  },
  methods: {
    clearSearch() {
      this.handleSearch(null);
    },
    handleSearch(searchValue) {
      this.searchValue = searchValue;
    },
  },
};
</script>
